import { IoIosRemoveCircle } from 'react-icons/io'
import { Button } from '../../../../components/Button'
import { Flex, Text } from '@chakra-ui/react'
import { FaPlusCircle } from 'react-icons/fa'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { Input } from '../../../../components/Form/Input'

export function Emails() {
    const {
        register,
        formState: { errors },
    } = useFormContext()
    const { fields, append, remove } = useFieldArray({
        name: 'emails',
    })

    const length = fields?.length

    return (
        <>
            <Text fontSize="12px" fontWeight="semibold" textAlign="center" py={'6px'} bg="#F5F5F5">
                EMAIL PARA COPIA DE NF/ BOLETO
            </Text>
            <Flex w="full" maxH="200px" overflowY="auto" flexDir="column" gap={2} p={1}>
                {fields?.map((field, index) => (
                    <Flex alignItems="end" gap={2}>
                        <Input key={field.id} width="100%" label={`Email ${index + 1}`} error={errors?.emails?.[index]?.email} {...register(`emails.${index}.email`)} />
                        <Button bgColor="#FF0000" onClick={() => remove(index)} size="sm" variant="ghost">
                            <IoIosRemoveCircle size={20} />
                        </Button>
                    </Flex>
                ))}
                {errors?.emails && (
                    <Text fontSize="12px" color="red.500">
                        {errors?.emails.message}
                    </Text>
                )}
            </Flex>
            <Button leftIcon={<FaPlusCircle size={20} />} onClick={() => append({ email: '' })} disabled={length >= 6}>
                Adicionar novo Email
            </Button>
        </>
    )
}
